import React from 'react';
import logo from '../assets/logo.png';

function Footer() {
  return (
    <footer className="footer">
      <div className="container-lg">
        <div className="row g-4">
          {/* Left Column */}
          <div className="col-lg-4 col-md-6">
            <a href="#" className="footer-logo d-flex align-items-center text-decoration-none">
              <img src={logo} alt="FastInQueue Logo" style={{ height: '40px', width: 'auto', marginRight: '8px' }} />
              <span className="fw-bold fs-4 text-primary-custom" style={{ letterSpacing: '0px' }}>FastInQueue</span>
            </a>
            <p className="mt-3">
              Transforming healthcare delivery through innovative digital solutions. Connecting patients with doctors for better healthcare outcomes.
            </p>
            <div className="social-icons">
              <a href="https://www.facebook.com/share/19D7Wk7CWE/" target="_blank" rel="noopener noreferrer" className="social-icon"><i className="bi bi-facebook"></i></a>
              <a href="https://x.com/fastinqueue" target="_blank" rel="noopener noreferrer" className="social-icon"><i className="bi bi-twitter"></i></a>
              <a href="https://www.instagram.com/fastinqueuepvtltd/" target="_blank" rel="noopener noreferrer" className="social-icon"><i className="bi bi-instagram"></i></a>
              <a href="https://www.linkedin.com/company/fastinqueue-private-limited/" target="_blank" rel="noopener noreferrer" className="social-icon"><i className="bi bi-linkedin"></i></a>
            </div>
          </div>

          {/* Middle Column */}
          <div className="col-lg-4 col-md-6">
            <h5>For Doctors</h5>
            <ul className="footer-links">
              <li className='d-none'><a href="#">On Board with FastInQueue</a></li>
              <li><a href="#">Doctor Portal Login</a></li>
              <li><a href="#">Features</a></li>
            </ul>
          </div>

          {/* Right Column */}
          <div className="col-lg-4 col-md-6">
            <h5>Support</h5>
            <ul className="footer-links">
              <li><a href="#">Privacy Policy</a></li>
              <li><a href="#">Contact Us</a></li>
              <li><a href="#">FAQs</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <p>&copy; 2026 FastInQueue. All rights reserved.</p>
          <div className="bottom-links">
            <a href="#">Privacy Policy</a>
            <a href="#">Terms of Service</a>
            <a href="#">Cookie Policy</a>
            <a href="#">HIPAA Compliance</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
